<template>
	<div>
		<strong>Page Not Found</strong>
	</div>
</template>

<script>
export default {
	beforeCreate () {
		this.$title('404')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/page/NotFound.vue